<header class="auth-header">

  <div class="container" *ngIf="!showMobileSearch">

    <div *ngIf="isCreate" class="alt-logo-section d-flex">
      <a [routerLink]="backUrl">
        <fa-icon size="2x" class="back-icon me-4" [icon]="icons.back"></fa-icon>
      </a>
      <a>
        <app-logo class="logo" primary></app-logo>
        <app-icon class="icon" primary></app-icon>
      </a>
    </div>

    <div *ngIf="!isCreate" class=" ms-auto me-auto">

      <div (click)="showSearchBar()" *ngIf="!searchBarFlag" class="input-section ms-auto me-auto">
        <span class="ms-4">Search</span>
        <fa-icon class="search-icon" [icon]="icons.search"></fa-icon>
      </div>

      <div class="search-bar listed-properties" [ngClass]="{'hide': !searchBarFlag}">
        <div class="search-bar-box">
          <p class="modal-clost-btn" (click)="closeSearchBar()" aria-label="Close">&times;</p>

          <h1 class="search-bar-title">Search</h1>
          <p class="search-bar-label">Find your accommadation or flights easily</p>
          <div class="item search_bar w-100">
            <!-- <app-search-bar *featureToggle="'corporate-accounts'" (onsearch)="closeSearchBar()" resource="listings"
              [service]="listingService">
            </app-search-bar> -->
            <tabset *featureToggle="'flights'">
              <tab [active]="activeTab=='' || (currentUrl === '/listings')" heading="Hotels & Apartments" id="tab1">
                <app-search-bar-v2 (onsearch)="closeSearchBar()" resource="listings" [service]="listingService">
                </app-search-bar-v2>
                  <!-- <div class="airline-dropdown-wrapper">
         
          <div  class="airline-select" >
            <div class="search-box">
              <fa-icon [icon]="icons.search" class="search-icon"></fa-icon>
              <input type="text"   
              [(ngModel)]="airlineSearch" 
              [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onSearchChange($event)" placeholder="Search by Hotel, City or Region" autocomplete="off">
                <fa-icon (click)="clear()" [icon]="icons.close" class="search-icon" *ngIf="selectedLocation?.name?.length"></fa-icon>
                <div *ngIf="locationLoading" class="spinner-border text-primary spinner-border-sm" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
            </div>
            <div class="airline-dropdown" *ngIf="showLocationDropdown">
              <ul class="airline-list">
                <li class="label-holder">Region</li>
                <li class="d-flex gap-2" *ngFor="let a of filteredLocations.regions" (click)="selectLocation(a)"
                [class.selected]="selectedLocation?.region_id === a.region_id">
                <fa-icon [icon]="icons.location" class="me-2"></fa-icon>
                <span class="airline-name">{{ a.name + ', ' + a.country_name }}</span>
              </li>
              <li class="label-holder">Hotel</li>
                <li class="d-flex gap-2" *ngFor="let a of filteredLocations.autoCompletedHotelData" (click)="selectLocation(a)"
                  [class.selected]="selectedLocation?.hid === a.hid">
                  <fa-icon [icon]="icons.hotel" class="me-2"></fa-icon>
                  <span class="airline-name">{{ a.name }}</span>
                </li>
                <li *ngIf="filteredLocations.length === 0" class="no-results">No airlines found</li>
              </ul>
            </div>
          </div>
        </div> -->
              </tab>
              <tab class="mr-4" [active]="(activeTab=='flights') || (currentUrl === '/flights')" heading="Flights" id="tab1">
                <app-flights-search-bar [id]="1" (onsearch)="closeSearchBar()"></app-flights-search-bar>
              </tab>
            </tabset>
          </div>
        </div>
        <div (click)="closeSearchBar()" class="search-bar-overlay">
        </div>
      </div>
    </div>

    <div *ngIf="isCreate" class="ms-auto me-auto"></div>


    <div class="action">
      <!-- <div class="right mr-5">
        <ul *ngIf="showCurrencyDropdown">
          <li class="dropdown">
            <a #dropdownToggle role="button dropdown-toggle" data-bs-toggle="dropdown" id="currencyDropdown"
              aria-expanded="false" class="d-flex align-items-center text-black">
              {{selectedCurrency || 'GBP'}}
              <fa-icon [icon]="icons.chevronDown" class="ms-2"></fa-icon>
            </a>
            <div class="dropdown-menu" aria-labelledby="currencyDropdown">
              <a *ngFor="let unit of currencies" class="d-block text-black p-2 ps-4 currency-link"
                (click)="swapCurrency(unit.name, $event)">{{unit.name}}</a>
            </div>
          </li>
        </ul>
      </div> -->
      <ng-container *ngIf="user">
        <!-- <a *ngIf="!isCreate" (click)="listYourProperty()" class="listing-link me-4 d-flex align-items-center">
          <span class="btn-toggle me-2">
            <fa-icon [icon]="icons.add"></fa-icon>
          </span>
          <span class="listing-text">List your property</span>
        </a> -->

        <!-- NOTIFICATIONS -->
        <div role="button" (click)="$event.stopPropagation()" class="me-3">
          <button class="notif__btn" (click)="toggleNotifications()" aria-label="Notifications">
            <fa-icon [icon]="icons.bell"></fa-icon>
            <span class="notif__dot" *ngIf="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
          </button>

          <div class="notif__panel" *ngIf="showNotifications">
            <h4 class="notif__hdr">Notifications</h4>

            <div class="notif__tabs">
              <button [class.active]="notifTab==='all'" (click)="setTab('all')">All</button>
              <button [class.active]="notifTab==='unread'" (click)="setTab('unread')">Unread</button>
            </div>

            <div class="notif__list">
              <ng-container *ngFor="let n of filteredNotifications; trackBy: trackById">
                <div class="notif__item read" [class.unread]="!n.read" (click)="openNotification(n)">
                  <div class="notif__bullet"></div>

                  <div class="notif__avatar" [style.background]="n.avatar ? 'transparent' : n.color">
                    <img *ngIf="n.avatar" [src]="n.avatar" alt="avatar" />
                    <span *ngIf="!n.avatar">{{ n.initials }}</span>
                  </div>

                  <div class="notif__content">
                    <p class="m-0">
                      <strong>{{ n.title }}</strong>
                      <span [innerHTML]="n.message"></span>
                    </p>
                  </div>

                  <p class="notif__time">{{ getDays(n.createdAt) }}</p>
                </div>
              </ng-container>

              <p class="notif__empty" *ngIf="filteredNotifications.length===0">
                No notifications
              </p>
            </div>

            <!-- <div class="notif__ftr">
      <button class="link" (click)="markAllAsRead()" [disabled]="unreadCount===0">Mark all as read</button>
      <button class="link" (click)="loadMore()" *ngIf="hasMore">Load more</button>
    </div> -->
          </div>
        </div>
        <button class="mobile-hamburger me-3" (click)="showMenu()">
          <fa-icon [icon]="icons.menu"></fa-icon>
        </button>

        <app-button dataTest="logout-btn" accent (click)="logout()" class="logout-btn">
          <fa-icon [icon]="icons.signout"></fa-icon>
          <span class="btn-text">Logout</span>
        </app-button>
      </ng-container>

      <ng-container *ngIf="!user">
        <div class="action">
          <a class="label-link" routerLink="/signup">Join us</a>

          <a class="btn btn-dark" routerLink="/login"> Login</a>

        </div>
      </ng-container>






    </div>
  </div>

</header>